export enum ImageType {
  Product = 'productImage',
  Normal = 'Normal',
  Banner = 'Banner'
}
